import DisplayAdsService from '@/api/admin/displayAds.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      searchTerm: '',
      totalRecords: 0,
    },
  },
  getters: {
    allDisplayAds: state => state.table,
  },
  actions: {
    async getDisplayAds({ commit }) {
      const displayAds = await DisplayAdsService.getDisplayAds()
      commit('SET_DISPLAY_ADS', displayAds)
      commit('SET_TOTALRECORDS', displayAds.length)
    },
  },
  mutations: {
    SET_DISPLAY_ADS(state, displayAds) {
      state.table.rows = displayAds
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
  },
}
